import React, { useEffect, useContext, useRef } from 'react';
import { AuthContext } from '../../contexts/AuthContext';
import AttendanceContent from './components/AttendanceContent';
import { useAttendance } from './hooks/useAttendance';
import AppShell from '../../components/layout/AppShell';
import { ConfirmDialog } from '../../components/ui';

function AttendancePage() {
  const { role: contextRole } = useContext(AuthContext);
  const role = contextRole || '';

  const {
    history, todayRecord, remarks, loading: attendanceLoading, actionLoading,
    error: attendanceError, adminUsernameFilter, showFlaggedOnly, missedCheckoutRequests,
    absenceType, absenceReason, vacationStartDate, vacationEndDate,
    missedCheckoutAttendanceId, missedCheckoutTime, missedCheckoutReason, startDate, endDate, page, pagination,
    editingRecordId, editStatus, editAssignedShift, editRemarks, editCheckInTime, editCheckOutTime,
    activeRemark,
    attendanceStateLabel, setRemarks, setAdminUsernameFilter, setAbsenceType, setAbsenceReason, setVacationStartDate, setVacationEndDate, setMissedCheckoutAttendanceId,
    setMissedCheckoutTime, setMissedCheckoutReason, setStartDate, setEndDate,
    setEditStatus, setEditAssignedShift, setEditRemarks, setEditCheckInTime, setEditCheckOutTime,
    openRemarkViewer, closeRemarkViewer,
    loadData, checkIn, checkOut, reportAbsence, goToPage, applyAdminFilter, clearFilters,
    toggleFlaggedOnly, submitMissedCheckoutRequest, approveMissedCheckoutRequest,
    resolveVisibleFlags,
    rejectMissedCheckoutRequest, applyQuickRange, startAdminEdit, cancelAdminEdit, saveAdminEdit, adminDeleteRecord,
    pendingDeleteId, confirmAdminDelete, cancelAdminDelete, exportCsv
  } = useAttendance(role);

  const initialLoad = useRef(loadData);
  useEffect(() => { initialLoad.current = loadData; }, [loadData]);
  useEffect(() => { initialLoad.current(); }, [role]);

  return (
    <AppShell>
      <AttendanceContent
        role={role}
        loading={attendanceLoading}
        actionLoading={actionLoading}
        error={attendanceError}
        remarks={remarks}
        onRemarksChange={setRemarks}
        absenceType={absenceType}
        absenceReason={absenceReason}
        vacationStartDate={vacationStartDate}
        vacationEndDate={vacationEndDate}
        onAbsenceTypeChange={setAbsenceType}
        onAbsenceReasonChange={setAbsenceReason}
        onVacationStartDateChange={setVacationStartDate}
        onVacationEndDateChange={setVacationEndDate}
        onReportAbsence={reportAbsence}
        missedCheckoutRequests={missedCheckoutRequests}
        missedCheckoutAttendanceId={missedCheckoutAttendanceId}
        missedCheckoutTime={missedCheckoutTime}
        missedCheckoutReason={missedCheckoutReason}
        onMissedCheckoutAttendanceIdChange={setMissedCheckoutAttendanceId}
        onMissedCheckoutTimeChange={setMissedCheckoutTime}
        onMissedCheckoutReasonChange={setMissedCheckoutReason}
        onSubmitMissedCheckoutRequest={submitMissedCheckoutRequest}
        onApproveMissedCheckoutRequest={approveMissedCheckoutRequest}
        onRejectMissedCheckoutRequest={rejectMissedCheckoutRequest}
        onResolveVisibleFlags={resolveVisibleFlags}
        attendanceStateLabel={attendanceStateLabel}
        todayRecord={todayRecord}
        history={history}
        adminUsernameFilter={adminUsernameFilter}
        onAdminFilterChange={setAdminUsernameFilter}
        showFlaggedOnly={showFlaggedOnly}
        onToggleFlaggedOnly={toggleFlaggedOnly}
        startDate={startDate}
        endDate={endDate}
        onStartDateChange={setStartDate}
        onEndDateChange={setEndDate}
        page={page}
        totalPages={pagination.totalPages || 1}
        onPrevPage={() => goToPage(page - 1)}
        onNextPage={() => goToPage(page + 1)}
        onApplyAdminFilter={applyAdminFilter}
        onClearFilters={clearFilters}
        onApplyQuickRange={applyQuickRange}
        editingRecordId={editingRecordId}
        editStatus={editStatus}
        editAssignedShift={editAssignedShift}
        editRemarks={editRemarks}
        editCheckInTime={editCheckInTime}
        editCheckOutTime={editCheckOutTime}
        onEditStatusChange={setEditStatus}
        onEditAssignedShiftChange={setEditAssignedShift}
        onEditRemarksChange={setEditRemarks}
        onEditCheckInTimeChange={setEditCheckInTime}
        onEditCheckOutTimeChange={setEditCheckOutTime}
        activeRemark={activeRemark}
        onOpenRemarkViewer={openRemarkViewer}
        onCloseRemarkViewer={closeRemarkViewer}
        onAdminEditStart={startAdminEdit}
        onAdminEditCancel={cancelAdminEdit}
        onAdminEditSave={saveAdminEdit}
        onAdminDelete={adminDeleteRecord}
        onExportCsv={() => exportCsv('all')}
        onExportPageCsv={() => exportCsv('page')}
        onRefresh={loadData}
        onCheckIn={checkIn}
        onCheckOut={checkOut}
      />

      <ConfirmDialog
        isOpen={Boolean(pendingDeleteId)}
        onClose={cancelAdminDelete}
        onConfirm={confirmAdminDelete}
        loading={actionLoading}
        title="Delete attendance record"
        message="This permanently removes the attendance record. This cannot be undone."
        confirmLabel="Delete"
      />
    </AppShell>
  );
}

export default AttendancePage;
